import React from 'react';

import {Notice as OriNotice} from '@ucloud-fe/react-components';

import {isMobile} from '../../service/deviceDetectService';

const Notice = props => {
  let {className = ''} = props;
  className = isMobile ()
    ? 'register-notice-fixed ' + className
    : className || 'u-mb20';
  return <OriNotice closable={false} {...props} className={className}>{props.message}</OriNotice>;
};

export default Notice;



// WEBPACK FOOTER //
// src/pc/components/Notice.jsx